import PropTypes from 'prop-types';

import styles from './Toggle.module.scss';

/**
 * Toggle 컴포넌트
 * - 토글 스위치 컴포넌트
 * - 스크린샷과 동일한 디자인: 파란색 배경, 흰색 원형 슬라이더
 *
 * @param {boolean} checked - 토글 활성화 여부
 * @param {Function} onChange - 토글 변경 핸들러
 * @param {boolean} disabled - 비활성화 여부
 * @param {string} className - 추가 CSS 클래스
 * @param {object} rest - 기타 HTML input 속성
 */
function Toggle({ checked = false, onChange, disabled = false, className = '', ...rest }) {
  const toggleClasses = [styles.toggle, className].filter(Boolean).join(' ');

  return (
    <label className={toggleClasses}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
        {...rest}
      />
      <span className={`${styles.slider} ${checked ? styles.sliderActive : ''}`}>
        <span className={styles.sliderThumb} />
      </span>
    </label>
  );
}

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Toggle;
